import { render, staticRenderFns } from "./part-table-info.vue?vue&type=template&id=38c0b866&scoped=true"
import script from "./part-table-info.vue?vue&type=script&lang=js"
export * from "./part-table-info.vue?vue&type=script&lang=js"
import style0 from "./part-table-info.vue?vue&type=style&index=0&id=38c0b866&prod&scoped=true&lang=scss"
import style1 from "./part-table-info.vue?vue&type=style&index=1&id=38c0b866&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c0b866",
  null
  
)

export default component.exports